import { AliasToken } from "antd/es/theme/internal";
import classNames from "classnames";

import { kebabize } from "@/shared/utils/string";

interface FlatIconProps extends React.HTMLAttributes<HTMLElement> {
	/** flat icon name, example: `fi-rr-circle-user` */
	name: string;
	size?: number;
	tokenColor?: keyof AliasToken;
}

export const UIFlatIcon: React.FC<FlatIconProps> = ({
	name,
	size,
	tokenColor,
	className,
	style,
	...props
}) => {
	const colorKey = tokenColor && kebabize(tokenColor);
	const tokenColorKey = colorKey && `ant-${colorKey}`;

	return (
		<i
			className={classNames(
				`fi ${name}`,
				"inline-flex items-center justify-center align-middle transition-colors",
				{ [`text-${tokenColorKey}`]: !!tokenColor },
				className
			)}
			style={{ fontSize: size ? `${size}px` : "inherit", ...style }}
			{...props}
		/>
	);
};
